module.exports = __webpack_public_path__ + "img/mainTopText.e96d2795.png";